<template>
	<Layout header-class="header-left-align" nav-alignment="left" :topbar-style="2">
		<!-- Start Slider area -->
		<div class="slider-area slider-style-2 variation-2 height-450 bg_image"
				 :style="{'background-image': `url(${require(`@/assets/images/banner-ai.png`)})`}">
			<div class="container">
				<h2 class="w-600 title text-left color-white mb--0 banner-text">企業級Agent中台</h2>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap sbg">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">企業級Agent中台</h2>
				<div style="margin-top: 48px; ">
					<p style="font-size: 18px">企業級生成式AI全棧解決方案：從模型選型到場景落地的端到端賦能。</p>
					<p style="font-size: 18px">構建覆蓋生成式AI全生命週期的工程化平台，深度融合算力資源、算法模型、領域知識及業務場景四大核心模塊，通過標準化智能流水線助力企業快速實現AI價值轉化，加速數字化升級進程。</p>
				</div>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">產品優勢</h2>
				<div class="product product-r" data-aos="fade-up" data-aos-delay="100">
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">智能算力中樞</div>
									<div class="t2">
										異構兼容：無縫整合信創與非信創架構，實現CPU/GPU多源算力的統一池化與動態調度<br>
										效能革命：基於模型特性與芯片算力指紋，智能匹配最優資源組合，GPU利用率提升50%+
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">企業知識引擎</div>
									<div class="t2">
										知識萃取：將非結構化業務數據智能轉化為可計算的向量知識圖譜<br>
										認知增強：為生成式AI注入企業專屬知識DNA，顯著提升私域問答準確率至行業領先水平
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">場景化AI工廠</div>
									<div class="t2">
										模型工廠：即開即用40+預置大模型，支持A/B測試快速驗證最佳技術路線<br>
										精調工坊：提供從數據清洗到RLHF的全流程微調工具鏈，打造企業專屬AI大腦<br>
										應用組裝台：通過可視化模塊編排，實現行業解決方案的積木式快速搭建，交付週期縮短70%
									</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
					<div class="pic">
						<img src="@/assets/images/agent1.png" style="border-radius: 12px;">
					</div>
				</div>
			</div>
		</div>

		<Separator />

		<div class="rwt-advance-tab-area rn-section-gap">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">適用場景</h2>
				<div class="product" data-aos="fade-up" data-aos-delay="100">
					<div class="pic">
						<img src="@/assets/images/agent2.png" style="border-radius: 12px;">
					</div>
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">全模態數據治理平台</div>
									<div class="t2">
										突破結構化數據治理邊界，首創非結構化數據（文檔/圖像/音視頻）的智能解析與價值萃取能力<br>
										構建企業全域數據血緣圖譜，使沉睡數據利用率提升300%，大數據平台ROI倍增
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">領域知識決策系統</div>
									<div class="t2">
										數字專家：基於企業知識圖譜訓練的行業大模型，具備：<br>
										✓ 多輪複雜業務推理能力<br>
										✓ 98%準確率的專業問答表現<br>
										✓ 持續進化的記憶學習機制
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">智能文檔認知中心</div>
									<div class="t2">
										秒級知識萃取：百頁文檔3秒生成執行摘要，支持跨文檔知識關聯挖掘<br>
										對話式深度分析，通過自然語言實現：關鍵條款定位、合規風險掃描、業務洞察提取功能
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">智能服務矩陣</div>
									<div class="t2">
										服務升級：響應速度＜0.8秒、準確率＞95%、人工工單下降60%<br>
										體驗升級：上下文感知的個性化服務、多業務場景無縫銜接、情緒識別與危機預警
									</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
				</div>
			</div>
		</div>

	</Layout>
</template>

<script>
import Layout from '@/components/common/Layout'
import Separator from '@/components/elements/separator/Separator'
import Swiper from "swiper";
import "swiper/css/swiper.css";
export default {
	name: 'Solution1',
	components: {Separator, Layout},
	data() {
		return {

		}
	},
	mounted() {
		new Swiper(".swiper-container", {
			autoplay: true,
			delay: 2000,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				renderBullet: function (index, className) {
					return '<span class="' + className + '">' + (index + 1) + "</span>";
				},
			},
		});
	}
}
</script>
<style lang="scss" scoped>
.sbg {
	background-image: url("../../../assets/images/sbg.jpg");
}
.product {
	margin-top: 72px;
	display: flex;
	.pic {
		width: 40%;
		img {
			width: 100%;
		}
	}
	.txt {
		width: 60%;
		.eee {
			width: 90%;
			text-align: left;
			.t1 {
				font-size: 24px;
				font-weight: 600;
				color: #000;
			}
			.t2 {
				margin-top: 12px;
				color: #000;
			}
		}
	}
}
@media only screen and (max-width: 768px) {
	.product {
		flex-direction: column;
		gap: 20px;
		.pic {
			width: 100%;
		}
		.txt {
			width: 100%;
		}

		&.product-r {
			flex-direction: column-reverse;
		}
	}
}
.swiper-container {
	width: 100%;
	.swiper-wrapper {
		width: 100%;
	}
	.swiper-slide {
		width: 100%;
		text-align: center;
		font-size: 18px;
		background: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	:deep(.swiper-pagination) {
		bottom: 30px;
		position: unset;
	}

	:deep(.swiper-pagination-bullet) {
		width: 20px;
		height: 20px;
		text-align: center;
		line-height: 20px;
		font-size: 12px;
		color: #000;
		opacity: 1;
		background: rgba(0, 0, 0, 0.2);
	}

	:deep(.swiper-pagination-bullet-active){
		color: #fff;
		background: #007aff;
	}
}
.banner-text {
	text-shadow:
		0 0 2px black,
		0 0 2px black,
		0 0 2px black,
		0 0 2px black;
}
</style>
